import React from 'react';
import { strings } from '../../../resources/strings';
import { useDnpLinksTable } from './useDnpLinksTable';

interface IOrdersInTransportTableHeaderProps {
}

const DnpLinksTableHeader: React.FC<IOrdersInTransportTableHeaderProps> = ({
}) => {

    const { getWidthColumns } = useDnpLinksTable();

    const widthColumn = getWidthColumns();

    return (
        <tr>
            <th style={{width:widthColumn.RequesterNameTitle}}>{strings.RequesterUser}</th>
            <th style={{width:widthColumn.CreatedAtTitle, minWidth:widthColumn.CreatedAtTitle, maxWidth:widthColumn.CreatedAtTitle}}>{strings.DateCriation}</th>
            <th style={{width:widthColumn.ExpirationDateTitle, minWidth:widthColumn.ExpirationDateTitle, maxWidth:widthColumn.ExpirationDateTitle}}>{strings.DateExpiration}</th>
            <th style={{width:widthColumn.LinkTitle, minWidth:widthColumn.LinkTitle, maxWidth:widthColumn.LinkTitle, textAlign:'center'}}>{strings.Link}</th>
        </tr>
    );
}

export {DnpLinksTableHeader};